"use strict";

exports.__esModule = true;

var CommonError =
/** @class */
function () {
  function CommonError(message, userMessage, errorCode, details, innerError) {
    this.userMessage = userMessage;
    this.details = details;
    this.innerError = innerError;
    this.message = message || '';
    this.code = errorCode || 'Unknown';

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(this);
    } else {
      this.stack = new Error().stack;
    }
  }

  return CommonError;
}();

exports.CommonError = CommonError;
CommonError.prototype = Object.create(Error.prototype);